import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { ParticipacionVinculacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class ParticipacionVinculacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getParticipacionVinculacionService(): Observable<BodyListResponse<ParticipacionVinculacionDTO>> {
    return this.http.get<BodyListResponse<ParticipacionVinculacionDTO>>(API_URL + '/api/v1/participacionVinculacion/todos');
  }

  guardarParticipacionVinculacionService(participacionVinculacionDTO: ParticipacionVinculacionDTO): Observable<ParticipacionVinculacionDTO> {
    return this.http.post<ParticipacionVinculacionDTO>(API_URL + '/api/v1/participacionVinculacion', participacionVinculacionDTO);
  }

  getParticipacionVinculacionPorCodigoParticipacionVinculacionService(codigoParticipacionVinculacion: string): Observable<BodyResponse<ParticipacionVinculacionDTO>> {
    return this.http.get<BodyResponse<ParticipacionVinculacionDTO>>(API_URL + '/api/v1/participacionVinculacion/' + codigoParticipacionVinculacion);
  }
}
